import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { rankBoards } from "@/mocks/rank";
import { formatHeat } from "@/utils/format";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line text-primary-600",
  down: "ri-arrow-down-line text-foreground-400",
  flat: "ri-subtract-line text-foreground-400",
};

export default function RankPreviewSection() {
  const board = rankBoards.today.slice(0, 6);

  return (
    <section className="w-full bg-background-100 px-4 py-12 md:px-8 md:py-16">
      <SectionHeading
        eyebrow="热榜"
        title="今日话题榜"
        desc="按公开讨论量排序，每小时刷新一次。"
        moreTo="/rank"
        moreLabel="查看完整榜单"
      />

      <ol className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {board.map((item, index) => (
          <li key={item.id}>
            <Link
              to={`/article/${item.id}`}
              className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-50 px-4 py-3.5 transition-colors hover:border-primary-300"
            >
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                  index < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                }`}
              >
                {index + 1}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="line-clamp-1 text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-700">
                  {item.title}
                </h3>
                <span className="mt-1 inline-flex items-center gap-2 font-label text-xs text-foreground-500">
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-800">{item.tag}</span>
                  <span>{formatHeat(item.heat)} 热度</span>
                </span>
              </div>
              <i className={`${trendIcon[item.trend]} shrink-0 text-lg`} aria-hidden="true"></i>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}